import angular from 'angular'

import MapSimple from './map-simple'
import extractRawElm from './extract-raw-elm'

import { stubTrue } from 'lodash-es'
import { offEvent, onEventPassive } from './on-event'

angular
  .module('ggs.utils')
  .factory('isDisplayedAsync', isDisplayedAsyncProvider)

const ANIMATION_NAME = 'animation-name'
const ANIMATION_START = 'animationstart'

const TIMEOUT_DELAY = 100
const TIMEOUT_SKIP_APPLY = false

function isDisplayedAsyncProvider(
  $q,
  domh,
  rootQs,
  $timeout,
  $rootScope,
  addIdPrefix) {

  const inProcess = MapSimple()
  const marker = addIdPrefix('is-displayed-async')
  const style = domh.createStyle(marker).attach().global(`
    @keyframes ${marker} {
      0% { visibility: inherit; }
    }
    ${rootQs}[${marker}], ${rootQs} [${marker}] {
      animation: 1ms ${marker};
    }`)

  $rootScope.$on('$destroy', onDestroy)
  return isDisplayedAsync

  function onDestroy() {
    style.detach()
  }

  function isDisplayedAsync($elm) {
    const elm = extractRawElm($elm)
    if (inProcess.has(elm)) {
      return inProcess.get(elm)
    }

    const div = document.createElement('div')
    div.setAttribute(marker, true)
    elm.appendChild(div)

    let wait = true
    const event = WaitEvent(div, ANIMATION_START, checkEvent, stubTrue)
    const timeout = $timeout(onTimeout, TIMEOUT_DELAY, TIMEOUT_SKIP_APPLY)
    const deferred = $q.defer()
    event.then(onResolve, onReject)
    return inProcess.set(elm, deferred.promise)

    function onResolve(val) {
      if (wait) {
        wait = false
        clear()
        deferred.resolve(val)
      }
    }

    function onReject(err) {
      if (wait) {
        wait = false
        clear()
        deferred.reject(err)
      }
    }

    function onTimeout() {
      if (wait) {
        wait = false
        clear()
        deferred.resolve(false)
      }
    }

    function clear() {
      elm.removeChild(div)
      event.kill()
      $timeout.cancel(timeout)
      inProcess.del(elm)
    }

    function checkEvent(event) {
      if (event.target !== div) {
        return false
      }

      let animationName = null
      if (event.animationName) {
        animationName = event.animationName
      } else {
        const styles = window.getComputedStyle(event.target)
        animationName = styles && styles.getPropertyValue(ANIMATION_NAME)
      }

      return animationName && (-1 !== animationName.indexOf(marker))
    }
  }

  function WaitEvent($elm, eventName, checkEvent, processEvent) {
    let wait = true
    const deferred = $q.defer()
    onEventPassive($elm, eventName, flush)
    deferred.promise.kill = kill
    return deferred.promise

    function kill() {
      if (wait) {
        wait = false
        clear()
      }
    }

    function flush(event) {
      if (checkEvent(event)) {
        if (wait) {
          wait = false
          clear()
          deferred.resolve(processEvent(event))
        }
      }
    }

    function clear() {
      offEvent($elm, eventName, flush)
    }
  }
}
